import MaterialsViewStore from "./MaterialsViewStore";

const materialsStoreList = [
  { name: "materialsViewStore", store: MaterialsViewStore },
];

export default materialsStoreList;